import { BreakPointCondition, UI, useBreakpointIf, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import {
  ColorCodedText,
  ColorCodedTextProps,
} from '../../../../../../../components/ColorCodedText';
import { FixedIncomeDetailsProps } from '../FixedIncomeDetails';

export const FixedIncomeSecondaryInfo: React.FC<FixedIncomeDetailsProps> = ({ product }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const getInfos = (): {
    label: string;
    value: string;
    coloredField?: ColorCodedTextProps['sign'];
  }[] => {
    const tabletFields = [
      { label: 'Data da compra', value: product.buyDateNormalized },
      { label: 'IOF', value: product.iofNormalized },
      { label: 'IR', value: product.irNormalized },
      { label: 'Valor compra', value: product.purchaseValueNormalized },
      { label: 'Valor líquido', value: product.netValueNormalized },
    ];
    const desktopFields = [
      { label: 'Código do ativo', value: product.productCodeNormalized },
      ...tabletFields,
    ];
    if (isMobile) {
      return [
        { label: 'Valor bruto', value: product.valueNormalized },
        { label: 'Vencimento', value: product.maturityDateNormalized },
        {
          label: 'Variação',
          value: product.variationNormalized,
          coloredField: product.variationType,
        },
        ...desktopFields,
      ];
    }
    if (isTablet) {
      return tabletFields;
    }
    return desktopFields;
  };

  const renderInfos = () => {
    const infos = getInfos();
    if (isMobile) {
      return (
        <VStack space={Spacing['stack.nano']}>
          {infos.map((item) => (
            <HStack justifyContent="space-between" key={item.label} w="full">
              <UI.Text color="neutral.black" variant="semibold">
                {item.label}
              </UI.Text>
              {item.coloredField ? (
                <ColorCodedText text={item.value} sign={item.coloredField} />
              ) : (
                <UI.Text color="neutral.darkest">{item.value}</UI.Text>
              )}
            </HStack>
          ))}
        </VStack>
      );
    }

    return (
      <FlatList
        key={`flatList-fixedIncome-detail${isTablet}`}
        style={{ overflow: 'visible' }}
        columnWrapperStyle={{ justifyContent: 'space-between' }}
        keyExtractor={(item) => `${item.label}-${isTablet}`}
        data={infos}
        renderItem={({ item }) => (
          <VStack space={Spacing['stack.quarck']}>
            <UI.Text variant="semibold">{item.label}</UI.Text>
            <UI.Text color="neutral.darkest">{item.value}</UI.Text>
          </VStack>
        )}
        numColumns={infos.length}
      />
    );
  };

  return (
    <VStack p={Spacing['inset.nano']} space={Spacing['stack.xxxs']} w="full">
      {!isMobile && <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />}
      <VStack p={Spacing['inset.xs']} bgColor={Color.background} borderRadius={BoxBorder.heavy}>
        {renderInfos()}
      </VStack>
    </VStack>
  );
};
